import { FilterValue } from '@src/design-system/filter-new';
import type { TRenderSelectedValuesCtx } from '../../types/filter-config';
import leadReferalApi from '@src/features/leads/services/lead-referal-api';
import { entityFilterIds } from '../../helpers/filter-none';

const SingleValue = ({ id }: { id: string | number }) => {
  const { data: status } = leadReferalApi.useFetchOne({ id });
  return <FilterValue>{status?.name}</FilterValue>;
};

export function LeadReferalFilterSelectedValues({
  filter,
}: TRenderSelectedValuesCtx) {
  return entityFilterIds(filter.value).map((v) => (
    <SingleValue
      key={v}
      id={v}
    />
  ));
}
